module.exports = __webpack_public_path__ + "static/img/jieshao3.09b1aee0.png";